import { useQuery } from "@tanstack/react-query";
import { ChevronRight, Plus } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

import * as api from "@/api/returns";
import { Button } from "@/components/ui/button";

function statusLabel(s: api.SessionStatus): string {
  return s === "open" ? "Открыта" : s === "completed" ? "Завершена" : "Отменена";
}

export function IntakeListPage(): React.ReactElement {
  const { data: sessions = [], isLoading } = useQuery({
    queryKey: ["returns", "sessions"],
    queryFn: api.listSessions,
  });

  return (
    <div className="space-y-4">
      <div className="sticky top-0 z-10 -mx-4 bg-background px-4 pb-2 md:-mx-6 md:px-6">
        <h1 className="text-xl font-bold">Приёмка возвратов</h1>
      </div>

      <Button asChild className="h-16 w-full text-base" size="xl">
        <Link to="/returns/new">
          <Plus className="size-5" /> Создать
        </Link>
      </Button>

      <div className="space-y-2">
        {isLoading && <p className="text-sm text-muted-foreground">Загрузка…</p>}
        {!isLoading && sessions.length === 0 && (
          <p className="text-sm text-muted-foreground">Ещё нет приёмок.</p>
        )}
        {sessions.map((s) => (
          <Link
            key={s.id}
            to={`/returns/sessions/${s.id}`}
            className="flex items-center justify-between rounded-md border bg-card p-4 active:bg-accent/40"
          >
            <div className="min-w-0">
              <div className="font-medium">
                {s.display_number ? `#${s.display_number} · ` : ""}
                {api.marketplaceTitle(s.marketplace)}
              </div>
              <div className="text-xs text-muted-foreground">
                {s.username} · {new Date(s.created_at).toLocaleString("ru-RU")} ·{" "}
                {s.items_count} поз. · {statusLabel(s.status)}
              </div>
            </div>
            <ChevronRight className="size-5 text-muted-foreground" />
          </Link>
        ))}
      </div>
    </div>
  );
}
